import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["partySize", "guestAmount", "flatRateAmount", "subtotal", "gratuityAmount", "discountAmount", "salesTaxExempt", "total", "lineItem", "addOnItem", "addOnQuantity"]
  static values = { url: String }

  connect() {
    this.calculate()
  }

  calculateFromInputs() {
    this.calculate()
  }

  perGuestChanged(event) {
    const value = parseFloat(event.target.value) || 0
    const wrapper = event.target.closest('.nested-line-item-wrapper')
    if (value > 0) {
      const flatRateInput = wrapper.querySelector('input[name*="flat_rate_amount"]')
      if (flatRateInput) flatRateInput.value = "0"

      const qtyInput = wrapper.querySelector('input[name*="[quantity]"]')
      const partySize = parseInt(this.partySizeTarget.value) || 1
      if (qtyInput && wrapper.dataset.newRecord === "true" && (parseInt(qtyInput.value) || 1) === 1) {
        qtyInput.value = partySize
      }
    }
    this.calculate()
  }

  flatRateChanged(event) {
    const value = parseFloat(event.target.value) || 0
    if (value > 0) {
      const wrapper = event.target.closest('.nested-line-item-wrapper')
      const perGuestInput = wrapper.querySelector('input[name*="amount_per_guest"]')
      if (perGuestInput) perGuestInput.value = "0"
    }
    this.calculate()
  }

  toggleAddOnQuantity(event) {
    const checkbox = event.target
    const itemId = checkbox.dataset.addOnItemId
    const qtyInput = this.addOnQuantityTargets.find(el => el.dataset.addOnItemId === itemId)
    if (qtyInput) qtyInput.disabled = !checkbox.checked
  }

  calculate() {
    const partySize = parseInt(this.partySizeTarget.value) || 0
    const guestAmount = this.hasGuestAmountTarget ? (parseFloat(this.guestAmountTarget.value) || 0) : 0
    const flatRateAmount = this.hasFlatRateAmountTarget ? (parseFloat(this.flatRateAmountTarget.value) || 0) : 0
    const gratuityAmount = parseFloat(this.gratuityAmountTarget.value) || 0
    const discountAmount = parseFloat(this.discountAmountTarget.value) || 0
    const salesTaxExempt = this.salesTaxExemptTarget.checked

    if (partySize === 0 || (guestAmount === 0 && flatRateAmount === 0)) return

    const params = new URLSearchParams({
      party_size: partySize,
      guest_amount: guestAmount,
      flat_rate_amount: flatRateAmount,
      gratuity_amount: gratuityAmount,
      discount_amount: discountAmount,
      sales_tax_exempt: salesTaxExempt
    })

    const allItems = []

    if (this.hasLineItemTarget) {
      this.lineItemTargets
        .filter(el => {
          const destroyInput = el.querySelector('input[name*="_destroy"]')
          return !destroyInput || destroyInput.value !== "1"
        })
        .forEach(el => {
          const perGuestInput = el.querySelector('input[name*="amount_per_guest"]')
          const flatRateInput = el.querySelector('input[name*="flat_rate_amount"]')
          const qtyInput = el.querySelector('input[name*="[quantity]"]')
          const perGuestDollars = perGuestInput ? parseFloat(perGuestInput.value) || 0 : 0
          const flatRateDollars = flatRateInput ? parseFloat(flatRateInput.value) || 0 : 0
          const quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1
          allItems.push({
            per_guest_cents: Math.round(perGuestDollars * 100),
            flat_rate_cents: Math.round(flatRateDollars * 100),
            quantity: quantity
          })
        })
    }

    if (this.hasAddOnItemTarget) {
      this.addOnItemTargets
        .filter(el => el.checked)
        .forEach(el => {
          const perGuestDollars = parseFloat(el.dataset.amountPerGuest) || 0
          const flatRateDollars = parseFloat(el.dataset.flatRateAmount) || 0
          const itemId = el.dataset.addOnItemId
          const qtyInput = this.hasAddOnQuantityTarget
            ? this.addOnQuantityTargets.find(q => q.dataset.addOnItemId === itemId)
            : null
          const quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1
          allItems.push({
            per_guest_cents: Math.round(perGuestDollars * 100),
            flat_rate_cents: Math.round(flatRateDollars * 100),
            quantity: quantity
          })
        })
    }

    if (allItems.length > 0) {
      params.set('line_items', JSON.stringify(allItems))
    }

    fetch(`${this.urlValue}?${params}`, {
      headers: { "Accept": "application/json" }
    })
    .then(response => response.json())
    .then(data => {
      this.subtotalTarget.value = data.subtotal
      this.totalTarget.value = data.total
    })
  }
}
